/**
 * Specifies the type of date (e.g. adjusted for holidays).
 * tag: 40144
 * @readonly
 * @enum {number} (int)
 */
export enum ProvisionOptionExerciseFixedDateType {
  /** Unadjusted */
  Unadjusted = 0,
  /** Adjusted */
  Adjusted = 1,
}
